import { Injectable, Inject } from '@angular/core';
import { OAuthService, AuthConfig, OAuthEvent } from 'angular-oauth2-oidc';
import { JwksValidationHandler, NullValidationHandler } from 'angular-oauth2-oidc';
import { filter, delay } from 'rxjs/operators';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { AppSettings } from '../../entities/AppSettings';
import { appSettings } from '../../modules/shared/components/appSettings';
import { authConfig } from '../../modules/shared/components/auth/auth.config';
import { IPermissionConfig } from '@framework/app';
import { Permissions } from '../../config/AppEnums';
import { ApiService } from '@services/api/api.service';
import { SelectItem } from 'primeng/components/common/selectitem';
import { BehaviorSubject, Subject } from 'rxjs';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Router } from '@angular/router';
import { PasswordExpiredComponent } from '../../modules/shared/components/password-expired/password-expired.component';
import { DialogService } from 'primeng/api';
import { DOCUMENT } from '@angular/common';
import { NbToastrService } from '@nebular/theme';
const STORAGE_KEY = 'currentOrganisationId';
const STORAGE_KEY_REDIRECT = 'redirectUrl';

@Injectable({
  providedIn: 'root'
})
export class IdentityAuthService {
  currentRouteUrl: any;
  userProfile: any;
  loadingUser: boolean = false;
  discoveryDocumentLoaded: boolean = false;
  private _appSettingsLoaded: boolean = false;
  public authenticating: boolean = false;
  public loadingAppSettings: boolean = true;
  public appSettingsLoadedEvent = new BehaviorSubject<boolean>(null);
  public currentOrganisationIdObserver = new BehaviorSubject(null);
  public userOrganisationsObserver = new BehaviorSubject(null);
  public permissionsChangedObserver = new BehaviorSubject(null);
  public userProfileObserver = new BehaviorSubject(null);
  public currentOrgFriendlyName: string;

  public _currentOrganisationId = '';
  public get currentOrganisationId() {
    return this._currentOrganisationId
  };
  public set currentOrganisationId(value) {
    var nav = false;
    if (value == this._currentOrganisationId)
      return;
    if (this._currentOrganisationId)
      nav = true;
    this._currentOrganisationId = value;
    this.permissionsChangedObserver.next(null);
    this.currentOrganisationIdObserver.next(value);
    this.storage.set(STORAGE_KEY, value);
    if (nav) {
      this.messageService.info('Swithing division ' + (this.currentOrganisation ? 'to ' + this.currentOrganisation.label: ''), 'Switching division')
      //this.router.navigateByUrl('/');
      this.authenticating = true;
      var _th = this;
      setTimeout(() => {
        _th._document.defaultView.location.reload();
      }, 100)
    }
  }
  public getOrg(orgId) {
    var filt = this.userOrganisationsOptions.filter(o => o.value == orgId);

    if (filt.length > 0)
      return filt[0];
  }

  public get currentOrganisation() {
    var filt = this.userOrganisationsOptions.filter(o => o.value == this.currentOrganisationId);

    if (filt.length > 0)
      return filt[0];
  };

  private _appSettings: any;
  public get AppSettingsLoaded() {
    return this._appSettingsLoaded;
  }

  constructor(private oauthService: OAuthService,
    private appSettingsService: AppSettingsService,
    private apiService: ApiService,
    public router: Router,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    public dialogService?: DialogService,
    @Inject(DOCUMENT) private _document?: Document,
    private messageService?: NbToastrService ) {
    this.configureWithNewConfigApi();
    this.apiService.authService = this;
    if (this.access_token)
      this.loadingUser = true;
    this.currentOrganisationId = this.storage.get(STORAGE_KEY) || '';
  }

  get access_token() {
    if (this.discoveryDocumentLoaded)
      return this.oauthService.getAccessToken();
    else return false;
  }

  private configureWithNewConfigApi() {
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.setStorage(sessionStorage);
    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.events
      .pipe(filter(e => e.type === 'session_terminated'))
      .subscribe(e => {
        this.logoff();
      });
    this.appSettingsService.getConfig().subscribe(appSettingsReturn => {
      var identityOptions = appSettingsReturn['identityOptions'];
      appSettings.authority = identityOptions['authority'];
      appSettings.client_id = identityOptions['client_id'];
      appSettings.scope = identityOptions['scope'];
      appSettings.apiServiceAddress = identityOptions['apiServiceAddress'];
      appSettings.primaryUrl = identityOptions['primaryUrl'];
      appSettings.secondaryUrl = identityOptions['secondaryUrl'];
      authConfig.issuer = identityOptions['authority'];
      authConfig.clientId = identityOptions['client_id'];
      authConfig.scope += identityOptions['scope'];

      this.oauthService.configure(authConfig);

      var self = this;
      this.oauthService.loadDiscoveryDocumentAndTryLogin().then(up => {
        this.discoveryDocumentLoaded = true;
        if (this.oauthService.hasValidAccessToken())
          this.loadUserProfile();
        else if (this.access_token) {
          this.authenticating = true;
          var _th = this;
          this.oauthService
            .silentRefresh()
            .then(info => { console.log('silent refresh complete'); _th.loadUserProfile(); })
            .catch(err => {
              console.error('refresh error', err); _th.loadUserProfile();
            });
        } else {
          this.authenticating = true;
          self.login();
        }

      });

    });
  }

  public isAuthenticated(): boolean {

    return this.oauthService.hasValidAccessToken();
  }

  public login() {
    this.oauthService.initImplicitFlow();
  }

  public logoff() {
    this.oauthService.logOut();
  }
  public triggerIfUserIsLoaded() {
    if (this.userProfile)
      this.userProfileObserver.next(this.userProfile);
  }
  loadUserProfile() {
    var _th = this;
    var redirectUrl = this.storage.get(STORAGE_KEY_REDIRECT) || '';

    this.loadingUser = true;
    this.oauthService.loadUserProfile().then(up => {
if (Object.prototype.toString.call((<any>up).name) === '[object Array]')
(<any>up).name = (<any>up).name[0];
      _th.userProfile = up;
      _th.loadingUser = false;
      _th.userProfileObserver.next(up);

      if (redirectUrl != '') {
        if (_th.router.url != redirectUrl)
          _th.router.navigateByUrl(redirectUrl);
        _th.storage.set(STORAGE_KEY_REDIRECT, '');
      }
    });
    this.loadingAppSettings = true;
    this.apiService.get('/api/config/appSettings')
      .subscribe(settings => {
        this.loadingAppSettings = false;
        this._appSettings = settings;
        this._appSettingsLoaded = true;
        this.appSettingsLoadedEvent.next(true);
        this.userOrganisations = settings.organisations;
        this._userOrganisationsOptions = this.userOrganisations.map(item => {
          return { label: item.name, value: item.id }
        })
        if (this.currentOrganisationId == '')
          this.currentOrganisationId = this.userOrganisationsOptions.length > 0 ? this.userOrganisationsOptions[0].value : '';
        if (this.userOrganisationsOptions.filter(o => o.value == this.currentOrganisationId).length == 0)
          this.currentOrganisationId = this.userOrganisationsOptions.length > 0 ? this.userOrganisationsOptions[0].value : '';

        if (this._appSettings.passwordExpiryStatus == 1 || this._appSettings.passwordExpiryStatus == 2) {
          const ref = this.dialogService.open(PasswordExpiredComponent, {
            data: {

            },
            header: 'Update password',
            width: '30%',
            closable: false
          });
        }
      });


  }



  fetchAppSettings() {
    return this.apiService.get('/api/config/appSettings')
  }

  private _userOrganisationsOptions: SelectItem[] = [];
  public get userOrganisationsOptions() {
    return this._userOrganisationsOptions
  }
  public Permissions = Permissions;
  private _userOrganisations: Array<IUserOrganisations> = [];
  public get userOrganisations() {
    return this._userOrganisations
  }
  public set userOrganisations(value) {
    this._userOrganisations = value;
    this.userOrganisationsObserver.next(value);

    this.permissionsChangedObserver.next(null);
  }
  public permissions: Array<Permissions> = [Permissions.SuperAdmin]; //TODO populate with call to api
  public hasPermissions(...requiredPermissions: Array<Permissions>): boolean {
    if (!this.userOrganisations || this.userOrganisations.length == 0)
      return false;
    var filteredOrgs = this.userOrganisations.filter(o => {
      return o.id == this.currentOrganisationId
    });
    if (filteredOrgs.length == 0)
      return false;
    var filteredOrg = filteredOrgs[0];
    if (filteredOrg.permissions.indexOf(Permissions.SuperAdmin) != -1 || filteredOrg.permissions.indexOf(Permissions.Admin) != -1)
      return true;
    var returnVal = true;
    if (requiredPermissions.length == 0)
      return false;
    requiredPermissions.forEach(perm => {
      if (filteredOrg.permissions.indexOf(perm) == -1)
        returnVal = false;
    });
    return returnVal;
  }
  public hasAnyPermissionsArr(requiredPermissions: Array<Permissions>): boolean {

    if (!this.userOrganisations || this.userOrganisations.length == 0)
      return false;
    var filteredOrgs = this.userOrganisations.filter(o => {
      return o.id == this.currentOrganisationId
    });
    if (filteredOrgs.length == 0)
      return false;
    var filteredOrg = filteredOrgs[0];
    if (filteredOrg.permissions.indexOf(Permissions.SuperAdmin) != -1 || filteredOrg.permissions.indexOf(Permissions.Admin) != -1)
      return true;
    var returnVal = false;
    if (requiredPermissions.length == 0)
      return;
    requiredPermissions.forEach(perm => {
      if (filteredOrg.permissions.indexOf(perm) != -1)
        returnVal = true;
    });
    return returnVal;
  }
  public hasAnyPermissions(...requiredPermissions: Array<Permissions>): boolean {
    return this.hasAnyPermissionsArr(requiredPermissions);
  }
}

export interface IUserOrganisations {
  id: any,
  name: any,
  description: any,
  permissions: Array<Permissions>
}
